import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
if ($('.horizontal-scroll').length) {

    gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

    let sections = gsap.utils.toArray(".sm-icon-contain");
    let container = document.querySelector(".horizontal-scroll");

    function example() {
        var tempScrollTop = $(window).scrollTop();
        // console.log("Activated scroll from top: " + tempScrollTop.toString());
    };

    function clickArray (){
        var widthDiv = $('.sm-icon-contain').width();
        var windowHeight = $( window ).height();
        var scrollTop     = $(window).scrollTop();
        var elementOffset = $('.horizontal-scroll').offset().top;
        var getHeight = $('.horizontal-scroll').height();

        var offsetWidth = (windowHeight / 4);
        var halfOffset = (windowHeight / 8);
        var distance = (elementOffset - getHeight) + offsetWidth;

        if( $('body.home').length ){

            if ($(window).width() >= 1400) {
                var distance_one = distance + offsetWidth;
                var distance_two = distance + (offsetWidth * 2);
                var distance_three = distance + (offsetWidth * 3);
                var distance_four = distance + (offsetWidth * 4);

                // console.log('home - over 1400px');
            }else{
                var distance_one = distance + 80;
                var distance_two = distance + (offsetWidth * 1);
                var distance_three = distance + (offsetWidth * 2);
                var distance_four = distance + (offsetWidth * 3);
                // console.log('home - under 1400px');
            }
        }else{

            if ($(window).width() >= 1400) {
                var distance_one = distance + halfOffset;
                var distance_two = distance + halfOffset + (offsetWidth * 1);
                var distance_three = distance + halfOffset + (offsetWidth * 2);
                var distance_four = distance + halfOffset + (offsetWidth * 3);
                // console.log('inside - over 1400px');
            }else{
                var distance_one = distance + halfOffset-30;
                var distance_two = distance + (offsetWidth * 1);
                var distance_three = distance + (offsetWidth * 2);
                var distance_four = distance + (offsetWidth * 3);
                // console.log('inside - under 1400px');
            }
        }

        // console.log(widthDiv);
        // console.log('Window Height: ' + windowHeight);
        // console.log('Half Marker: ' + halfOffset);
        // console.log('elementOffset: ' + elementOffset);
        // console.log('Height of Horizontal Scroll: ' + getHeight);
        // console.log('Original distance from top: ' + distance);
        // console.log('Original distance of item_1 from top: ' + distance_one);
        // console.log('Original distance of item_2 from top: ' + distance_two);
        // console.log('Original distance of item_3 from top: ' + distance_three);
        // console.log('Original distance of item_4 from top: ' + distance_four);

        gsap.utils.toArray(".sm-icon-contain").forEach(function (a) {
            a.addEventListener("click", function(e) {
                var tempScrollTop = $(window).scrollTop();
                // console.log('Temp Scroll Top: ' + tempScrollTop);

                if ($(this).hasClass("item_1")) {
                    // console.log(0 + distance_one);
                    $("html, body").animate({ scrollTop: (0 + distance_one) }, "fast");
                }
                if ($(this).hasClass("item_2")) {
                    // console.log(0 + distance_two);
                    $("html, body").animate({ scrollTop: (0 + distance_two) }, "fast");
                }
                if ($(this).hasClass("item_3")) {
                    // console.log(0 + distance_three);
                    $("html, body").animate({ scrollTop: (0 + distance_three) }, "fast");
                }
                if ($(this).hasClass("item_4")) {
                    // console.log(0 + distance_four);
                    $("html, body").animate({ scrollTop: (0 + distance_four) }, "fast");
                }
            });
        });
    }

    $(window).resize(function(){
       clickArray();
    });



    let scrollTween = gsap.to(sections, {
        ease: "none",
        scrollTrigger: {
            trigger: ".horizontal-scroll",
            start: "0% 100%",
            pin: false,
            scrub: 1,
            onEnter: function(){
                clickArray();
            },
            // markers: {startColor: "purple", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20},
            // base vertical scrolling on how wide the horizontal-scroll is so it feels more natural.
            // end: () => `+=${container.offsetWidth}`
        }
    });



    //Desktop
    ScrollTrigger.matchMedia({"(min-width: 993px)": function() {
            let scrollTween = gsap.to(sections, {
                ease: "none",
                scrollTrigger: {
                    trigger: ".horizontal-scroll",
                    start: "40% 50%",
                    pin: true,
                    scrub: 1,
                    // markers: {startColor: "orange", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20},
                    // markers: true,
                    // base vertical scrolling on how wide the horizontal-scroll is so it feels more natural.
                    // end: () => `+=${container.offsetWidth}`
                }
            });
        },
        //Mobile
        "(max-width: 993px)": function() {
            let scrollTween = gsap.to(sections, {
                ease: "none",
                scrollTrigger: {
                    trigger: ".horizontal-scroll",
                    start: "top top",
                    pin: false,
                    scrub: 1,
                    // markers: true,
                    // base vertical scrolling on how wide the horizontal-scroll is so it feels more natural.
                    // end: () => `+=${container.offsetWidth}`
                }
            });
        }
    });


    //Desktop
    ScrollTrigger.matchMedia({"(min-width: 993px)": function() {
            gsap.to('.item_1', {
                ease: "none",
                toggleClass : 'text-center sm-icon-contain',
                scrollTrigger: {
                    trigger: ".item_1",
                    // markers: true,
                    start: "bottom 100%",
                    end: "bottom 75%",
                    toggleActions: "play complete reverse reset",
                    toggleClass:  "is-active",
                    onEnter: function(){
                        example();

                    }
                }
            });
            gsap.to('.item_2', {
                ease: "none",
                toggleClass : 'text-center sm-icon-contain',
                scrollTrigger: {
                    trigger: ".item_2",
                    // markers: true,
                    start: "bottom 75%",
                    end: "bottom 50%",
                    toggleActions: "play complete reverse reset",
                    toggleClass:  "is-active",
                    onEnter: function(){
                        example();

                    }
                }
            });
            gsap.to('.item_3', {
                ease: "none",
                toggleClass : 'text-center sm-icon-contain',
                scrollTrigger: {
                    trigger: ".item_3",
                    // markers: true,
                    start: "bottom 50%",
                    end: "bottom 25%",
                    toggleActions: "play complete reverse reset",
                    toggleClass:  "is-active",
                    onEnter: function(){
                        example();

                    }
                }
            });
            gsap.to('.item_4', {
                ease: "none",
                toggleClass : 'text-center sm-icon-contain',
                scrollTrigger: {
                    trigger: ".item_4",
                    // markers: true,
                    start: "bottom 25%",
                    end: "bottom 0%",
                    toggleActions: "play complete reverse reset",
                    toggleClass:  "is-active",
                    onEnter: function(){
                        example();

                    }
                }
            });
        },
        //Mobile
        "(max-width: 993px)": function() {
            gsap.to('.item_1', {
                ease: "none",
                toggleClass : 'text-center sm-icon-contain',
                scrollTrigger: {
                    trigger: ".item_1",
                    // markers: true,
                    start: "top 90%",
                    end: "bottom 50%",
                    toggleActions: "play complete reverse reset",
                    toggleClass:  "is-active",
                }
            });
            gsap.to('.item_2', {
                ease: "none",
                toggleClass : 'text-center sm-icon-contain',
                scrollTrigger: {
                    trigger: ".item_2",
                    // markers: true,
                    start: "top 90%",
                    end: "bottom 50%",
                    toggleActions: "play complete reverse reset",
                    toggleClass:  "is-active",
                }
            });
            gsap.to('.item_3', {
                ease: "none",
                toggleClass : 'text-center sm-icon-contain',
                scrollTrigger: {
                    trigger: ".item_3",
                    // markers: true,
                    start: "top 90%",
                    end: "bottom 50%",
                    toggleActions: "play complete reverse reset",
                    toggleClass:  "is-active",
                }
            });
            gsap.to('.item_4', {
                ease: "none",
                toggleClass : 'text-center sm-icon-contain',
                scrollTrigger: {
                    trigger: ".item_4",
                    // markers: true,
                    start: "top 90%",
                    end: "bottom 50%",
                    toggleActions: "play complete reverse reset",
                    toggleClass:  "is-active",
                }
            });
        }
    });
}